function returnDateTime(time){
    if(time==null||time==''||time==undefined||time=='undefined'){
        return ''
    }else{
        let ctime = new Date(time);
        let year = ctime.getFullYear();
        let month = ctime.getMonth()+1;
        let day = ctime.getDate();
        let hour = ctime.getHours();
        let minute = ctime.getMinutes();
        let second = ctime.getSeconds();
        month = month < 10 ? "0"+month:month;
        day = day < 10 ? "0"+day:day;
        hour = hour < 10 ? "0"+hour:hour;
        minute = minute < 10 ? "0"+minute:minute;
        second = second < 10 ? "0"+second:second;
        return year+'-'+month+'-'+day+' '+ hour +':'+ minute+':'+second;
    }
}
function returnDate(time){
    if(time==null||time==''||time==undefined||time=='undefined'){
        return ''
    }else{
        let ctime = new Date(time);
        let year = ctime.getFullYear();
        let month = ctime.getMonth()+1;
        let day = ctime.getDate();
        let hour = ctime.getHours();
        let minute = ctime.getMinutes();
        let second = ctime.getSeconds();
        month = month < 10 ? "0"+month:month;
        day = day < 10 ? "0"+day:day;
        return year+'-'+month+'-'+day;
    }            
}

function returnUserInfo(structureUis){
        var groupUi = {};
        if (structureUis != null) {
          for (const iterator of structureUis) {
            if (groupUi[iterator.ui] == null) {
              groupUi[iterator.ui] = [];
            }
            groupUi[iterator.ui].push(iterator);
          }
        }
        return groupUi;
}


function filtration(data){
     if(data==null){
         return ''
     }else{
         return data
     }
}
export default {
    returnDateTime:returnDateTime,
    returnDate:returnDate,
    returnUserInfo:returnUserInfo,
    filtration:filtration
}



//////////////////
// WEBPACK FOOTER
// ./static/js/time.js
// module id = null
// module chunks = 